import { LineAPI } from '../../../api/schematicmap/LineAPI';

export class LinesCommand {
    list(edition, successCallback, errorCallback) {
        const apiResult = LineAPI.list(edition);
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch((err) => {
            if (undefined !== errorCallback) {
                errorCallback(err.message);
            }
        });
    }
}
